import { salesDataClientSourceTaskSending } from 'commons/service/bank/salesData'
import { SalesDataClientSourceSendTaskPayload } from 'commons/types/DTO/bank/salesDataSourceWebPage'
import { WriteHook, useMutationManager } from 'state-manager'

export const useSalesDataClientSourceTaskSending: WriteHook<SalesDataClientSourceSendTaskPayload, void> = (opts) =>
  useMutationManager<SalesDataClientSourceSendTaskPayload, void>(salesDataClientSourceTaskSending, opts)
